// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-8kNm","image":"styles_image__xRlZ5","forgotPasswordText":"styles_forgotPasswordText__F9J3v","resetLink":"styles_resetLink__Oc1ee"};